import { useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";

export default function InviteDialog({ open, onOpenChange, onInvite, user }) {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("member");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    try {
      await onInvite({ email, role });
      setEmail("");
      setRole("member");
      onOpenChange(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="admin-dialog" data-testid="admin-invite-dialog">
        <DialogHeader>
          <DialogTitle className="admin-dialog-title" data-testid="admin-invite-title">
            Invite someone to Cardfolio
          </DialogTitle>
          <DialogDescription data-testid="admin-invite-description">
            They’ll receive a secure link to create their account.
          </DialogDescription>
        </DialogHeader>
        <form className="admin-invite-form" onSubmit={submit} data-testid="admin-invite-form">
          <label className="auth-field" data-testid="admin-invite-email-field">
            <span>Email address</span>
            <input
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              type="email"
              placeholder="dealer@example.com"
              required
              data-testid="admin-invite-email-input"
            />
          </label>
          <label className="auth-field" data-testid="admin-invite-role-field">
            <span>Starting role</span>
            <select
              value={role}
              onChange={(event) => setRole(event.target.value)}
              data-testid="admin-invite-role-select"
            >
              <option value="member">Member</option>
              {user.role === "owner" && <option value="admin">Admin</option>}
            </select>
          </label>
          <button
            className="admin-primary-button"
            type="submit"
            disabled={isSubmitting}
            data-testid="admin-send-invite-button"
          >
            {isSubmitting ? "Sending…" : "Send invitation"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}